export const LANDING_CONTENT = {
  hero: {
    kicker: 'Para distribuidores/revendedores da Baixada Santista',
    title: 'Sua equipe perde até 60 horas por mês com planilhas e retrabalho. Dá para mudar isso.',
    subtitle:
      'Organize sua operação com um sistema simples, feito para a sua realidade, e recupere tempo para focar no que realmente faz sua empresa crescer.',
    cta: 'Quero recuperar essas horas',
    ctaMessage: 'Quero agendar uma demonstração',
    urgency: 'Enquanto você decide, o retrabalho continua consumindo horas da sua equipe.',
  },

  pain: {
    title: 'Se o seu dia está assim, você não está sozinho',
    intro:
      'Muitas empresas da região ainda trabalham no improviso — e pagam caro por isso em tempo, dinheiro e desgaste.',
    items: [
      { icon: 'fa-solid fa-boxes-stacked', text: 'Estoque sem confiança: sobra de um lado, falta do outro.' },
      { icon: 'fa-solid fa-rotate', text: 'Retrabalho diário com processos manuais e lançamentos repetidos.' },
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Erros operacionais que viram atraso, devolução e dor de cabeça.' },
      { icon: 'fa-solid fa-chart-line', text: 'Financeiro sem visão clara para decidir com segurança.' },
      { icon: 'fa-solid fa-shuffle', text: 'Sensação constante de desorganização na operação.' },
      { icon: 'fa-regular fa-clock', text: 'Tempo perdido em tarefas que não geram resultado.' },
      { icon: 'fa-solid fa-hand-holding-dollar', text: 'Comissão de vendedor calculada na mão, sujeita a erro e discussão.' },
      { icon: 'fa-solid fa-store', text: 'Sem catálogo para o cliente consultar: tudo depende de você ou de um vendedor para responder.' },
      { icon: 'fa-solid fa-file-invoice-dollar', text: 'Emitir boleto exige passos demais — e atrasa o recebimento.' },
    ],
  },

  solution: {
    title: 'Você não precisa de mais trabalho. Precisa de rotina organizada.',
    intro: 'O sistema foi pensado para distribuidores e revendedores que precisam de controle no dia a dia, sem complicação.',
    cards: [
      {
        icon: 'fa-solid fa-warehouse',
        title: 'Mais controle na operação',
        text: 'Tenha uma visão clara do que entra, do que sai e do que precisa de atenção agora.',
      },
      {
        icon: 'fa-solid fa-wand-magic-sparkles',
        title: 'Menos retrabalho',
        text: 'Padronize processos e pare de refazer as mesmas tarefas todos os dias.',
      },
      {
        icon: 'fa-solid fa-magnifying-glass-chart',
        title: 'Decisão com mais segurança',
        text: 'Enxergue os números do negócio sem depender de planilhas espalhadas.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão sem briga',
        text: 'Calcule automaticamente a comissão de cada vendedor e elimine erros e desentendimentos na hora do acerto.',
      },
      {
        icon: 'fa-solid fa-store',
        title: 'Catálogo público de produtos',
        text: 'Compartilhe seu catálogo com clientes sem precisar de vendedor: preços, fotos e disponibilidade sempre atualizados.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Boleto em poucos cliques',
        text: 'Emita cobranças diretamente pelo sistema e receba mais rápido, sem depender de planilha ou banco separado.',
      },
    ],
  },

  proof: {
    title: 'Case real da Praia Grande: 60 horas por mês recuperadas',
    intro:
      'Um distribuidor de Praia Grande, com faturamento mensal na faixa de 100k, enfrentava rotina puxada com controles manuais.',
    stat: { number: '60h', label: 'economizadas por mês' },
    paragraphs: [
      'Depois da implantação acompanhada e customizações, a operação ficou mais previsível e a equipe deixou de gastar tempo em tarefas repetitivas.',
      'Isso significa mais tempo para vender melhor, atender clientes e corrigir gargalos antes que virem prejuízo.',
    ],
    highlight: 'Resultado: economia de aproximadamente 60 horas por mês.',
    cta: 'Quero o mesmo resultado',
    ctaMessage: 'Vi o case de Praia Grande e quero entender como recuperar tempo na minha operação.',
  },

  benefits: {
    title: 'O que muda na prática',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Clareza',
        text: 'Você sabe exatamente o que está acontecendo na operação e no financeiro.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Você deixa de depender de memória, caderno e planilhas soltas.',
      },
      {
        icon: 'fa-regular fa-clock',
        title: 'Tempo',
        text: 'Menos horas em tarefas repetitivas e mais foco no crescimento do negócio.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas da Baixada escolhem a gente',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema simples e adaptável ao tamanho da sua operação.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para você não ficar perdido.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
      { icon: 'fa-solid fa-truck-ramp-box', text: 'Foco total em distribuidores — não em empresas de todos os tipos.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'É difícil implementar?',
        answer:
          'Não. A implantação é acompanhada, em etapas claras, para sua equipe ganhar segurança desde o primeiro uso.',
      },
      {
        question: 'Vai dar mais trabalho no começo?',
        answer:
          'O objetivo é o contrário: reduzir retrabalho rápido. Você entra com acompanhamento para organizar sem parar a operação.',
      },
      {
        question: 'Serve para distribuidores desse porte?',
        answer:
          'Sim. O sistema foi pensado para a realidade de distribuidores com faturamento mensal na faixa de 60k a 150k.',
      },
    ],
  },

  ctaFinal: {
    title: 'Cada semana no modo planilha é uma semana de tempo perdido',
    subtitle:
      'Agende sua demonstração e veja, na prática, como organizar sua operação e recuperar horas valiosas da sua equipe.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração para entender como recuperar tempo na minha operação.',
  },

  headlineVariations: [
    'Sua equipe perde até 60 horas por mês com planilhas e retrabalho. Dá para mudar isso.',
    'Empresas que trabalham com venda de produtos da Baixada Santista estão recuperando 60 horas por mês. Você ainda está no modo planilha?',
    'Pare de apagar incêndio no estoque e recupere 60 horas por mês na sua operação.',
  ],

  seo: {
    title: 'Sistema de Gestão para Empresas de venda de produtos da Baixada Santista | 77Gestão',
    description:
      'Organize sua operação e economize até 60 horas por mês. Sistema simples para distribuidores e revendedores, com implantação acompanhada e suporte humano. Agende uma demonstração.',
  },
};
